<template>
  <page-outline :title="$t('Webheader.payment_schedule_list')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="mt-3 align-items-center">
          <b-col cols="auto">
            <back-button class="btnFilter_2 mr-2 btn-back" :returnUrl="returnUrl"></back-button>
          </b-col>

          <b-col class="d-flex justify-content-end" cols="auto">
            <b-button class="btnFilter_2 mr-2 w-100" @click="exportPaymentSchedule">
              <i class="fa-light fa-upload"></i>
              {{ $t('mandate.export') }}
            </b-button>

            <b-button class="btnFilter_2 mr-2 w-100" @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>

            <b-button class="btnFilter_2 w-100" @click="onRefresh">
              <i class="fa-light fa-rotate-right"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>
        <hr class="mx-auto" />

        <!-- Filtres -->
        <b-row v-if="displayFilter" class="min-w-100 justify-content-start align-items-center">
          <b-col cols="3">
            <span class="filter-item-title d-block mb-1">{{ $t('mandate.unique_mandate_rf') }}</span>
            <input v-model.trim="UMR" class="filter-item-content w-100" style="padding:0.13rem" :placeholder="$t('mandate.unique_mandate_rf')" />
          </b-col>

          <b-col cols="3">
            <span class="filter-item-title d-block mb-1">{{ $t('mandate.status_collection') }}</span>
            <select v-model="Status" class="filter-item-content w-100" style="padding:0.35rem">
              <option value="All">──────────</option>
              <option v-for="s in statuses" :key="s.value" :value="s.value">{{ $t(s.label) }}</option>
            </select>
          </b-col>

          <b-col v-if="viewMode === 'calendar'" cols="3">
            <div>
              <span class="filter-item-title d-block mb-1">{{ $t('Webheader.date_begin') }}</span>
              <datetime-picker-custom
                format="YYYY-MM-DD"
                periodFull
                id="filter-datebegin"
                class="mr-3"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateBeginFilter}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                style="padding:0.35rem"
                :maxLength="19"
                :placeholderValue="$t('common.datepicker_format_date3')"
                inputIcon="fa-solid fa-calendar"
                :showTime="false"
                v-model="dateBeginFilter"/>
            </div>
          </b-col>

          <b-col v-if="viewMode === 'calendar'" cols="3">
            <div>
              <span class="filter-item-title d-block mb-1">{{ $t('Webheader.date_end') }}</span>
              <datetime-picker-custom
                format="YYYY-MM-DD"
                periodFull
                id="filter-dateend"
                class="mr-3"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateEndFilter}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                style="padding:0.35rem"
                :maxLength="19"
                :placeholderValue="$t('common.datepicker_format_date3')"
                inputIcon="fa-solid fa-calendar"
                :showTime="false"
                v-model="dateEndFilter"/>
            </div>
          </b-col>

          <b-col v-if="viewMode === 'list'" cols="3">
            <div>
              <span class="filter-item-title d-block mb-1">{{ $t('mandate.date_due_next_start') }}</span>
              <datetime-picker-custom
                format="YYYY-MM-DD"
                periodFull
                id="filter-datebegin"
                class="mr-3"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateBeginFilterNext}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                style="padding:0.35rem"
                :maxLength="19"
                :placeholderValue="$t('common.datepicker_format_date3')"
                inputIcon="fa-solid fa-calendar"
                :showTime="false"
                v-model="dateBeginFilterNext"/>
            </div>
          </b-col>

          <b-col v-if="viewMode === 'list'" cols="3">
            <div>
              <span class="filter-item-title d-block mb-1">{{ $t('mandate.date_due_next_end') }}</span>
              <datetime-picker-custom
                format="YYYY-MM-DD"
                periodFull
                id="filter-dateend"
                class="mr-3"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateEndFilterNext}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                style="padding:0.35rem"
                :maxLength="19"
                :placeholderValue="$t('common.datepicker_format_date3')"
                inputIcon="fa-solid fa-calendar"
                :showTime="false"
                v-model="dateEndFilterNext"/>
            </div>
          </b-col>

          <b-row class="min-w-100 justify-content-end align-items-center">

              <b-col cols="12" class="d-flex justify-content-end mt-3">
                <b-button class="btnFilter_2 mr-2 w-100" @click="clearFilterFields" :disabled="!hasInputFilter">
                  {{ $t('common.rst') }}
                </b-button>
                <b-button class="btnFilter_2 w-100" @click="onRefresh">
                  {{ $t('common.srch') }}
                </b-button>
              </b-col>
          </b-col>
            </b-row>
        </b-row>

        <hr class="mx-auto mb-4" v-if="displayFilter"/>
        <!-- Contenu principal -->
        <b-row>
          <b-col cols="12">
            <b-card class="position-relative">
              <!-- Bouton de basculement de vue -->
              <div class="position-absolute" style="right: 20px; top: 10px;">
                <a href="#" @click.prevent="toggleView" class="small text-primary text-decoration-underline">
                  {{ viewMode === 'calendar' ? $t('mandate.switch_list_view') : $t('mandate.switch_calendar') }}
                </a>
              </div>

              <!-- Transition entre vues -->
              <transition name="fade" mode="out-in">

                <!-- Vue Calendaire -->
                <div v-if="viewMode === 'calendar'" key="calendar-view" class="p-3">
                  <div class="calendar-header d-flex justify-content-center align-items-center mb-3">
                    <b-button variant="light" @click="prevYear">
                      <i class="fa-light fa-chevron-left"></i>
                    </b-button>
                    <h3 class="mx-3">{{ currentYear }}</h3>
                    <b-button variant="light" @click="nextYear">
                      <i class="fa-light fa-chevron-right"></i>
                    </b-button>
                  </div>

                  <div class="calendar-grid-container">
                    <table class="calendar-grid">
                      <thead>
                        <tr>
                          <th>{{ $t('mandate.month') }}</th>
                          <th v-for="day in 31" :key="day">{{ day }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(month, monthIndex) in months" :key="month">
                          <td>{{ month }}</td>
                          <td
                            v-for="day in 31"
                            :key="day"
                            :class="cellClass(monthIndex, day)"
                            :title="getCellTitle(monthIndex, day)"
                            @click="navigateToDetails(monthIndex + 1, day)">
                            <div v-if="filteredDebitMap[monthIndex + 1 + '-' + day]" class="amount-cell">
                              {{ formatAmount(filteredDebitMap[monthIndex + 1 + '-' + day].totalAmount) }}
                              <!-- <span
                                v-if="filteredDebitMap[monthIndex + 1 + '-' + day].count > 1"
                                class="plus-symbol"
                              >+</span> -->
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="legend mt-3">
                    <!-- <span class="legend-item">
                      <span class="box box-history"></span>
                      {{ $t('mandate.past_debit') }}
                    </span>

                    <span class="legend-item">
                      <span class="box box-multiple-history"></span>
                      {{ $t('mandate.multiple_past_debits') }}
                    </span> -->
                    <span class="legend-item">
                      <span class="box box-debit"></span>
                      {{ $t('mandate.total') }} =
                      {{ $t('mandate.total_past') }} +
                      0 ({{ $t('mandate.total_reimbursed') }}) +
                      {{ $t('mandate.total_error') }} +
                      {{ $t('mandate.total_expected') }}
                    </span>
                    <!-- <span class="legend-item">
                      <span class="box box-multiple"></span>
                      {{ $t('mandate.multiple_debits') }}
                    </span>
                    <span class="legend-item">
                      <span class="box box-mixed"></span>
                      {{ $t('mandate.mixed_debit') }}
                    </span> -->
                  </div>
                </div>

                <!-- Vue Liste -->
                <div v-else key="list-view" class="mt-4">
                  <spinner v-if="activateSpinner"></spinner>
                  <b-table v-else-if="listItemsPaymentSchedule.length > 0"
                    striped
                    hover
                    responsive
                    :items="listItemsPaymentSchedule"
                    :fields="fields"
                    class="table table-striped"
                    style="margin-bottom:0"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDir"
                    @head-clicked="sortTable"
                    :key="refreshKey"
                    :empty-text="$t('common.security.no_result')"
                    @row-clicked="onRowClicked">
                    <template #cell(amount)="data">
                      {{ formatCurrency(data.item.amount) }}
                    </template>
                    <!-- <template #cell(periodicity)="data">
                      <span v-if="data.value !== ''"> {{ data.value }} </span>
                      <span v-else>-</span>
                    </template> -->
                    <template #cell(frequency)="data">
                      <span v-if="data.value !== ''">{{ $t('mandate.frequency_type_' + data.value) }}</span>
                      <span v-else>-</span>
                    </template>
                    <template #cell(nextDueDate)="data">
                      <span v-if="data.value !== ''"> {{ formatDate(data.item.nextDueDate) }} </span>
                      <span v-else>-</span>
                    </template>
                    <template #cell(status)="data">
                      <span v-if="data.value !== ''" :class="['chip','chip--' + statusVariant(data)]">{{ $t('mandate.status_payment_schedule_' + data.value) }}</span>
                      <span v-else>-</span>
                    </template>
                    <template #cell(actions)="{ item }">
                      <b-link @click.stop.prevent="onRowClicked(item)" class="text-decoration-none">
                        {{ $t('mandate.view_details') }}
                      </b-link>
                    </template>
                  </b-table>
                  <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('common.no_result') }}
                    </span>
                  </div>
                  <b-row class="mt-5">
                    <b-col>
                      <cm-pagination
                        :maxResultsByPage="paginationObject.maxResults"
                        :firstIndex="paginationObject.firstIndex"
                        :nbResultsTotal="paginationObject.nbResultsTotal"
                        :refreshEvent="paginationObject.refresh">
                      </cm-pagination>
                    </b-col>
                  </b-row>
                </div>
              </transition>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import { loadPage } from '@/helpers/routing'
import { paymentSchedules, frequencies, formatDate } from '@/data/mockData'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import moment from 'moment-timezone'
import { errorMessageAlert } from "@/helpers/alert"
import Spinner from "@/components/common/spinner.vue"
import Pagination from '@/components/common/pagination.vue'
import BackButton from '@/components/common/backButton.vue'

export default {
  name: 'PaymentScheduleListUnit',
  components: {
    BackButton,
    'page-outline': PageOutline,
    'datetime-picker-custom': dateTimePicker,
    spinner: Spinner,
    'cm-pagination': Pagination
  },
  data() {
    return {
      activateSpinner: false,
      currentYear: new Date().getFullYear(),
      viewMode: 'calendar',
      dateBeginFilter: null,
      dateBeginFilterNext: null,
      dateEndFilter: null,
      dateEndFilterNext: null,
      displayFilter: true,
      debtorNameFilter: '',
      filterConditions: {},
      frequencyFilter: 'All',
      frequencies: frequencies,
      listItemsPaymentSchedule: [],
      listItemsPaymentScheduleSansP: [],
      nextDueDate: '',
      fields: [
        { key: 'UMR', label: this.$t('mandate.unique_mandate_rf'), sortable: true, class: 'text-center' },
        { key: 'debtor', label: this.$t('mandate.dbtr'), sortable: true, class: 'text-center' },
        { key: 'amount', label: this.$t('mandate.amt'), sortable: true, class: 'text-center' },
        { key: 'frequency', label: this.$t('mandate.frequency_type'), sortable: true, class: 'text-center' },
        // { key: 'periodicity', label: this.$t('mandate.periodicity'), sortable: true, class: 'text-center' },
        { key: 'nextDueDate', label: this.$t('mandate.date_due_next'), sortable: true, class: 'text-center' },
        { key: 'status', label: this.$t('mandate.status_collection'), sortable: true, class: 'text-center status-col' },
        { key: 'actions', label: this.$t('mandate.actions'), class: 'text-center' }
      ],
      pageCounter: 0,
      paginationObject: {},
      PaymentScheduleListExport: {},
      showDaySelectionModal: false,
      selectedDaySchedules: [],
      selectedDate: null,
      sortBy: '',
      sortDir: false,
      Status: 'All',
      statuses: [
        { value: '1', label: 'mandate.status_payment_schedule_1' },
        { value: '0', label: 'mandate.status_payment_schedule_0' }
      ],
      months: Array.from({ length: 12 }, (_, i) => this.$t(`mandate.month_${i + 1}`)),
      timezone: '+00:00',
      UMR: ""
    }
  },
  created() {
    this.timezone = moment.tz.guess()
    this.IdPaymentScheduleBulk = this.$route.query.IdPaymentScheduleBulk
    this.returnUrl = '/payment-schedules/bulk'

    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    // this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getPaymentSchedule(index)
      that.pageCounter = 0
    })

    this.pageCounter = 0
    this.onRefresh()
  },
  computed: {
    hasInputFilter () {
      return !!this.UMR || this.Status !== 'All' || this.dateBeginFilter || this.dateEndFilter || this.dateBeginFilterNext || this.dateEndFilterNext
    },
    filteredDebitMap() {
      const map = {}

      this.listItemsPaymentScheduleSansP.forEach(item => {
        if (item.nextDueDate) {
          const [year, month, day] = item.nextDueDate.split('-').map(Number)
          if (year === this.currentYear) {
            const key = `${month}-${day}`
            if (!map[key]) map[key] = { totalAmount: 0, count: 0, items: [], TotalPasse: 0, TotalRembourse: 0, TotalErreur: 0, TotalPrevu: 0 }

            map[key].totalAmount += Number(item.Total || 0)
            map[key].TotalPasse += Number(item.TotalPasse || 0)
            map[key].TotalRembourse += Number(item.TotalRembourse || 0)
            map[key].TotalErreur += Number(item.TotalErreur || 0)
            map[key].TotalPrevu += Number(item.TotalPrevu || 0)
            map[key].count = 1
            map[key].items.push({ ...item, type: 'debit' })
          }
        }
      })

      return map
    },
    modalTitle() {
      if (!this.selectedDate) return ''
      const { day, month } = this.selectedDate
      return `Échéanciers du ${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${this.currentYear}`
    },
    totalModalAmount() {
      return this.selectedDaySchedules.reduce((sum, schedule) => sum + schedule.amount, 0)
    }
  },

  methods: {
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getPaymentSchedule()
    },
    cellClass(monthIndex, day) {
      const key = `${monthIndex + 1}-${day}`
      const data = this.filteredDebitMap[key]
      const lastDay = new Date(this.currentYear, monthIndex + 1, 0).getDate()

      if (day > lastDay) return 'cell-disabled'
      if (!data) return 'cell-empty'

      // const hasHistory = data.items.some(i => i.type === 'history')
      // const hasDebit = data.items.some(i => i.type === 'debit')
      //
      // if (!hasDebit && hasHistory) return data.count > 1 ? 'cell-debit cell-multiple-history' : 'cell-debit cell-history'
      // if (hasDebit && !hasHistory) return data.count > 1 ? 'cell-debit cell-multiple' : 'cell-debit cell-single'

      return 'cell-debit cell-single'
    },
    clearFilterFields() {
      this.UMR = ''
      this.Status = 'All'
      this.dateBeginFilter = null
      this.dateEndFilter = null
      this.dateBeginFilterNext = null
      this.dateEndFilterNext = null
    },
    exportPaymentSchedule () {
      let that = this
      const statusValue = this.Status === 'All' ? '' : this.Status || ''
      let params = {
        UMR: this.UMR || '',
        Status: statusValue,
        StartDate: this.dateBeginFilterNext,
        EndDate: this.dateEndFilterNext,
        IdPaymentScheduleBulk: this.IdPaymentScheduleBulk || ''
      }
      this.$engine.paymentSchedule.getPaymentSchedule(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.PaymentSchedule.length

        this.PaymentScheduleListExport = resp.data.PaymentSchedule || []

        this.PaymentScheduleListExport.forEach(item => {
          if (['0'].includes(String(item.status))) {
            item.nextDueDate = '-'
          }
          // else if (item.frequency === '1') {
          //   item.nextDueDate = this.computeNextDueDate(item)
          // }
        })

        this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
        let firstLine = this.$t('mandate.unique_mandate_rf') + ';' +
          this.$t('mandate.dbtr') + ';' +
          this.$t('mandate.rsn_debit') + ';' +
          this.$t('mandate.date_first_debit') + ';' +
          this.$t('mandate.frequency_type') + ';' +
          this.$t('mandate.periodicity') + ';' +
          this.$t('mandate.nb_occurences') + ';' +
          this.$t('mandate.date_end') + ';' +
          this.$t('mandate.amt') + ';' +
          this.$t('mandate.date_due_next') + ';' +
          this.$t('mandate.status_collection') + '\r\n'
        let lines = ''
        for (var i = 0; i < this.PaymentScheduleListExport.length; i++) {
          let result = this.PaymentScheduleListExport[i]
          let statusPaymentSchedule = this.statuses.find(
            status => status.value === String(result.status)
          )?.label
          let frequency = result.frequency === '1' ? this.$t('mandate.frequency_type_1') : this.$t('mandate.frequency_type_0')
          statusPaymentSchedule = this.$t(statusPaymentSchedule)
          lines += result.UMR + ';' +
                   result.debtor + ';' +
                   result.reason + ';' +
                   result.firstDebitateDate + ';' +
                   frequency + ';' +
                   result.periodicity + ';' +
                   result.nbOccurence + ';' +
                   result.endDate + ';' +
                   result.amount + ';' +
                   result.nextDueDate + ';' +
                   statusPaymentSchedule+ '\r\n'
        }
        let data = firstLine + lines
        this.$f7.hidePreloader()
        let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let downloadLink = document.createElement('a')
        let today = moment()
        let fileName = this.$t('Webheader.payment_schedule_list') + '_' + today.unix() + '.csv'
        if (
        this.$f7.device.os === 'android' ||
        this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    formatAmount(amount) {
      if (amount >= 1_000_000) return (amount / 1_000_000).toFixed(1) + 'M'
      if (amount >= 1_000) return (amount / 1_000).toFixed(1) + 'K'
      return amount.toFixed(0)
    },
    formatCurrency (n) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }).format(n)
    },
    formatDate(dateIso) {
      return dateIso.replace("T", " ")
    },
    formatDateC(d) {
      return d.toISOString().split('T')[0]
    },
    getCellTitle(monthIndex, day) {
      const key = `${monthIndex + 1}-${day}`
      const data = this.filteredDebitMap[key]
      if (!data) return ''

      const lines = [
        `${this.$t('mandate.total_past')} : ${this.formatCurrency(data.TotalPasse || 0)}`,
        `${this.$t('mandate.total_reimbursed')} : ${this.formatCurrency(data.TotalRembourse || 0)}`,
        `${this.$t('mandate.total_error')} : ${this.formatCurrency(data.TotalErreur || 0)}`,
        `${this.$t('mandate.total_expected')} : ${this.formatCurrency(data.TotalPrevu || 0)}`,
        `----- ${this.$t('mandate.total')} : ${this.formatCurrency(data.totalAmount || 0)} -----`
      ]

      return lines.join('\n')
    },
    getPaymentSchedule(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      const statusValue = this.Status === 'All' ? '' : this.Status || ''
      let params = {
        UMR: this.UMR || '',
        Status: statusValue,
        StartDate: this.dateBeginFilterNext,
        EndDate: this.dateEndFilterNext,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        IdPaymentScheduleBulk: this.IdPaymentScheduleBulk || ''
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.paymentSchedule.getPaymentSchedule(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.PaymentSchedule.length

        let PaymentScheduleList = {}

        PaymentScheduleList = resp.data.PaymentSchedule

        PaymentScheduleList.forEach(item => {
          if (['0'].includes(String(item.status))) {
            item.nextDueDate = '-'
          }
        })

        that.updatePaymentSchedule(PaymentScheduleList)

          const paramsSansP = {
            UMR: this.UMR || '',
            Status: statusValue,
            StartDate: this.dateBeginFilter,
            EndDate: this.dateEndFilter,
            IdPaymentScheduleBulk: this.IdPaymentScheduleBulk || '',
            CurrentYear: this.currentYear
          }
          if (this.filterConditions.OrderByField) {
            paramsSansP.OrderByField = this.filterConditions.OrderByField
          }
          if (this.filterConditions.OrderByDirection) {
            paramsSansP.OrderByDirection = this.filterConditions.OrderByDirection
          }

          return this.$engine.paymentSchedule.getPaymentSchedule(paramsSansP)
        })
        .then((respSansP) => {
        const items = respSansP.data.PaymentScheduleCalendar || []

        items.forEach(item => {
          if (['0'].includes(String(item.status))) {
            item.nextDueDate = '-'
          }
        })


        that.listItemsPaymentScheduleSansP = items

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
    },
    navigateToDetails(month, day) {
      const key = `${month}-${day}`
      const data = this.filteredDebitMap[key]

      if (!data) return

      if (data.count === 1) {
        const hasNextDueDate = data.items.some(item => item.nextDueDate)
        if (hasNextDueDate) {
          const nextDueDate = data.items.find(item => item.nextDueDate).nextDueDate
          loadPage(this, { url: '/payment-schedules/day/' + nextDueDate + "?currentYear=" + this.currentYear + "&nextDueDate=" + nextDueDate })
        }
      }
      // else {
      //   const hasNextDueDate = data.items.some(item => item.nextDueDate)
      //   const hasHistoryDate = data.items.some(item => item.HistoryDate)
      //
      //   if (hasNextDueDate && !hasHistoryDate) {
      //     const nextDueDate = data.items.find(item => item.nextDueDate).nextDueDate
      //     loadPage(this, { url: '/payment-schedules/day/' + nextDueDate + "?currentYear=" + this.currentYear + "&nextDueDate=" + nextDueDate })
      //   } else if (!hasNextDueDate && hasHistoryDate) {
      //     const historyDate = data.items.find(item => item.HistoryDate).HistoryDate
      //     loadPage(this, { url: '/payment-schedules/day/' + historyDate + "?currentYear=" + this.currentYear + "&HistoryDate=" + historyDate })
      //   } else if (hasNextDueDate && hasHistoryDate) {
      //     const nextDueDate = data.items.find(item => item.nextDueDate).nextDueDate
      //     const historyDate = data.items.find(item => item.HistoryDate).HistoryDate
      //     loadPage(this, { url: '/payment-schedules/day/' + nextDueDate + "?currentYear=" + this.currentYear + "&HistoryDate=" + historyDate + "&nextDueDate=" + nextDueDate })
      //   }
      // }
    },
    nextYear() {
      this.currentYear++
      this.getPaymentSchedule()
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getPaymentSchedule()
    },
    onRowClicked(item) {
      if (item && item.id) {
        loadPage(this, { url: '/payment-schedules/unit/details/' + item.id + '?IdPaymentScheduleBulk=' + this.IdPaymentScheduleBulk  })
      }
    },
    prevYear() {
      this.currentYear--
      this.getPaymentSchedule()
    },
    refreshList () {
      this.page = 1
      this.transactions = this.transactions.slice()
      this.applyFilter()
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'UMR',
        'debtor',
        'amount',
        'frequency',
        'nextDueDate',
        'status'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection
      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    statusVariant(status) {
      const variants = {
        0: 'secondary',
        1: 'success'
      }
      return variants[status.value] || 'secondary'
    },
    toggleView() {
      this.viewMode = this.viewMode === 'calendar' ? 'list' : 'calendar'
    },
    updatePaymentSchedule(PaymentScheduleList) {
      this.listItemsPaymentSchedule = PaymentScheduleList
    },
    formatDateToYMD(date) {
      const d = new Date(date)

      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped>
/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Calendrier */
.calendar-grid-container {
  overflow-x: auto;
}

.calendar-grid {
  width: 100%;
  min-width: 1000px;
  border-collapse: collapse;
  table-layout: fixed;
}

.calendar-grid th,
.calendar-grid td {
  border: 1px solid #eee;
  text-align: center;
  padding: 0;
  height: 25px;
  font-size: 10px;
}

.calendar-grid th:first-child,
.calendar-grid td:first-child {
  width: 6%;
  text-align: left;
  padding-left: 5px;
  font-weight: bold;
}

.cell-empty {
  background-color: #f8f9fa;
}

.cell-disabled {
  background-color: #e9ecef;
}

.cell-debit {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.cell-debit:hover {
  opacity: 0.8;
}

.cell-single {
  background-color: #17a2b8;
  color: white;
  font-weight: bold;
}

.cell-multiple {
  background-color: #007bff;
  color: white;
  font-weight: bold;
}

.cell-multiple-history {
  background-color: #fd7e14;
  color: white;
  font-weight: bold;
}

.cell-history {
  background-color: #ffc107;
  color: white;
  font-weight: bold;
}

.cell-mixed {
  background: #6f42c1;
  color: white;
  font-weight: bold;
}

.amount-cell {
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.plus-symbol {
  font-size: 10px;
  margin-left: 2px;
}

/* Légende */
.legend {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.box {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 5px;
  border: 1px solid #ccc;
}

.box-debit {
  background-color: #17a2b8;
}

.box-multiple {
  background-color: #007bff;
}

.box-history {
  background-color: #ffc107;
}

.box-multiple-history {
  background-color: #fd7e14;
}

.box-mixed {
  background-color: #6f42c1;
}

/* Modal */
.schedule-item {
  transition: background-color 0.2s ease;
}

.schedule-item:hover {
  background-color: #f8f9fa;
}

.amount-text {
  font-size: 1.1rem;
  color: #28a745;
}

.summary-box {
  border: 1px solid #dee2e6;
}

.status-col { width: 180px; }
.chip{
  --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151;
  display:inline-flex; align-items:center; justify-content:center;
  height:28px; min-width:150px; padding:0 .75rem; border-radius:999px;
  font-size:.75rem; font-weight:600; letter-spacing:.2px;
  border:1px solid var(--chip-border); background-color:var(--chip-bg); color:var(--chip-fg); white-space:nowrap;
}
.chip--success{ --chip-border:#16a34a; --chip-bg:rgba(22,163,74,.10); --chip-fg:#166534; }
.chip--warning{ --chip-border:#f59e0b; --chip-bg:rgba(245,158,11,.12); --chip-fg:#92400e; }
.chip--danger{  --chip-border:#ef4444; --chip-bg:rgba(239,68,68,.10); --chip-fg:#991b1b; }
.chip--secondary{ --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151; }
.chip--info{ --chip-border:#60a5fa; --chip-bg:rgba(96,165,250,.12); --chip-fg:#0b4a6f; }
</style>
